import { NavLink } from 'react-router-dom';
import './Nav.css';

export const Nav = () => (
  <div className="nav-tabs-container">
    <div className="nav-tabs">
      <NavLink
        to="/"
        role="button"
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
      >
        Dataset
      </NavLink>
      <NavLink
        to="analysis"
        role="button"
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
      >
        Analysis Builder
      </NavLink>
    </div>
  </div>
);
